var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8154 0.818226L12.8154 12.7782H14.0435L14.0435 0.818226H12.8154Z",
    fill: "#BFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5612 1.38887L0.739128 12.3749L1.60746 13.1818L13.4295 2.19579L12.5612 1.38887Z",
    fill: "#BFFF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0434 0.818176L1.1733 0.818176L1.1733 1.95935L14.0434 1.95935V0.818176Z",
    fill: "#BFFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.0639c2e8cc349eb0f20a623b8e1e6faf.svg";
export { ForwardRef as ReactComponent };